import { csx } from '@vtex/admin-ui'

export const alert = csx({
  marginTop: '1rem',
  width: '100% !important',
  gap: '10px',

  '> div': {
    display: 'grid',
    gap: '8px',
    gridAutoFlow: 'column',
  },

  p: {
    margin: '0 !important',
    display: 'grid',
    gap: '8px',
    gridAutoFlow: 'column',
    maxWidth: 'unset !important',
  },
})

export const alertIcon = csx({
  '> div:first-child > svg': {
    display: 'none !important',
    margin: '0 !important',
  },
})
